import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTencentqqComponent } from './simple-icons-tencentqq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTencentqqComponent ],
    exports:      [ SimpleIconsTencentqqComponent ],
    bootstrap:    []
})
export class SimpleIconsTencentqqModule {}
